import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/components/Analytics/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/components/Hoory/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/components/popups/NotificationPanel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/components/popups/Promo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingProvider"] */ "/var/src/popokgamingv2-prd/context/LinearLoading/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MetaCheckProvider"] */ "/var/src/popokgamingv2-prd/context/MetaChck/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationsProvider"] */ "/var/src/popokgamingv2-prd/context/Translations/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/node_modules/next/font/local/target.css?{\"path\":\"app/Fonts/index.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../public/fonts/Rubik/Rubik-Regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Rubik/Rubik-Italic.woff2\",\"weight\":\"410\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Rubik/Rubik-Medium.woff2\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Rubik/Rubik-Bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Rubik/Rubik-Black.woff2\",\"weight\":\"900\",\"style\":\"normal\"}],\"display\":\"swap\"}],\"variableName\":\"rubik\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/var/src/popokgamingv2-prd/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/ar.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/en.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/es.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/fr.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/hi.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/id.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/pt.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/ru.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/th.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/vi.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/zh.png");
